import React from "react";
import "./Scrollingtxt.css";

const Scrollingtxt = () => {
  return (
    <div className="scroll-left">
      <p>
        {/* Devotees are requested to pay through QR Code for poojas | Devotees are
        requested to pay through online :
        https://www.aptemples.org/en-in/temples/SMSTMDP/aboutTemple | After
        paying through QR Code, Please send Whatsapp message to 9491006567 -
        Paid receipt, gothram, names, address and performance date. */}
        శని త్రయోదశి పూజ.  శని దోష పరిహారార్థం అమావాస్య. 13-06-2026.  పౌర్ణమి.27-06-2026
      </p>
    </div>
  );
};

export default Scrollingtxt;
